module.exports = __webpack_public_path__ + "static/media/office_4@2x.e6099139.jpg";